import { useEffect, useRef, useState } from "react";
import Tooltip from "../Tooltip";
import { MascotDisplay } from "./MascotDisplay";
import { MascotDropdown } from "./MascotDropdown";
import { SelectorContainer } from "./MascotSelector.styles";
import { useMascot } from "@/shared/hooks";

export const MascotSelector = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { currentMascot, currentMascotSrc, selectMascot, catalog } = useMascot();

    const handleClick = () => {
        setIsOpen(prev => !prev);
    };

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <SelectorContainer ref={containerRef}>

            {isOpen ? (
                <MascotDisplay
                    src={currentMascotSrc}
                    label={currentMascot?.label ?? ''}
                    isSelected={true}
                    disableScale
                    onClick={handleClick}
                />
            ) : (
                <Tooltip title="¿Qué mood tenés hoy?" position="bottom">
                    <MascotDisplay
                        src={currentMascotSrc}
                        label={currentMascot?.label ?? ''}
                        isSelected={false}
                        disableScale
                        onClick={handleClick}
                    />
                </Tooltip>
            )}
            {
                isOpen &&
                <MascotDropdown
                    catalog={catalog}
                    selectedId={currentMascot?.id ?? null}
                    onSelected={(id) => { selectMascot(id); setIsOpen(false); }}
                />
            }
        </SelectorContainer >
    );
};
